// MotoParts — cart stability + runtime localization (ES / IT / FR).
(function () {
  'use strict';

  function currentLang() {
    var raw = (document.documentElement.lang || 'es').toLowerCase();
    if (raw.indexOf('it') === 0) return 'it';
    if (raw.indexOf('fr') === 0) return 'fr';
    return 'es';
  }

  var strings = {
    es: {
      adding: 'Añadiendo...', applying: 'Aplicando...',
      addError: 'No se pudo añadir al carrito. Inténtalo de nuevo.',
      applied: function (code) { return 'Código "' + code + '" aplicado correctamente.'; },
      invalid: function (code) { return 'El código "' + code + '" no es válido, ya se usó o no aplica a estos productos.'; }
    },
    it: {
      adding: 'Aggiunta in corso...', applying: 'Applicazione...',
      addError: 'Impossibile aggiungere il prodotto al carrello. Riprova.',
      applied: function (code) { return 'Codice "' + code + '" applicato correttamente.'; },
      invalid: function (code) { return 'Il codice "' + code + '" non è valido, è già stato usato o non si applica a questi prodotti.'; }
    },
    fr: {
      adding: 'Ajout en cours...', applying: 'Application...',
      addError: 'Impossible d’ajouter le produit au panier. Réessayez.',
      applied: function (code) { return 'Code « ' + code + ' » appliqué avec succès.'; },
      invalid: function (code) { return 'Le code « ' + code + ' » n’est pas valide, a déjà été utilisé ou ne s’applique pas à ces produits.'; }
    }
  };

  function init() {
    if (window.__mtCartFixesReady) return;
    window.__mtCartFixesReady = true;

    var lang = currentLang();
    var copy = strings[lang];

    // Dawn can look for Quantity-* even though the drawer uses Drawer-quantity-*.
    // Supporting both prevents quantity reset errors in the cart drawer.
    try {
      if (typeof CartItems !== 'undefined' && CartItems.prototype) {
        CartItems.prototype.resetQuantityInput = function (id) {
          var input = this.querySelector('#Quantity-' + id) || this.querySelector('#Drawer-quantity-' + id);
          if (!input) return;
          var original = input.getAttribute('value');
          if (original !== null) input.value = original;
          this.isEnterPressed = false;
        };
      }
    } catch (e) {}

    // Keep AJAX URLs inside the active locale (/it/, /fr/ or /).
    window.routes = window.routes || {};
    if (!window.routes.root_url) {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        window.routes.root_url = Shopify.routes.root;
      } else if (lang === 'it') {
        window.routes.root_url = '/it/';
      } else if (lang === 'fr') {
        window.routes.root_url = '/fr/';
      } else {
        window.routes.root_url = '/';
      }
    }

    // Only translate the known custom add-to-cart error. Leave every other alert untouched.
    if (!window.__mtNativeAlert) window.__mtNativeAlert = window.alert.bind(window);
    window.alert = function (message) {
      var text = String(message == null ? '' : message);
      if (lang !== 'es' && text === strings.es.addError) text = copy.addError;
      return window.__mtNativeAlert(text);
    };

    document.addEventListener('click', function (event) {
      var discountButton = event.target.closest && event.target.closest('[data-mt-aplicar-descuento]');
      if (discountButton && lang !== 'es') {
        setTimeout(function () {
          if (discountButton.disabled) discountButton.textContent = copy.applying;
        }, 0);
      }

      var addButton = event.target.closest && event.target.closest('[data-mt-add-btn]');
      if (addButton && lang !== 'es') {
        setTimeout(function () {
          if (addButton.disabled) addButton.textContent = copy.adding;
        }, 0);
      }
    });

    function localizeDiscountMessage(node) {
      if (!node || lang === 'es') return;
      var text = (node.textContent || '').trim();
      var applied = text.match(/^Código "(.+)" aplicado correctamente\.$/);
      if (applied) {
        node.textContent = copy.applied(applied[1]);
        return;
      }
      var invalid = text.match(/^El código "(.+)" no es válido, ya se usó o no aplica a estos productos\.$/);
      if (invalid) node.textContent = copy.invalid(invalid[1]);
    }

    function watchDiscountMessages(root) {
      (root || document).querySelectorAll('[data-mt-descuento-mensaje]').forEach(function (node) {
        if (node.dataset.mtLocalizationObserved === '1') return;
        node.dataset.mtLocalizationObserved = '1';
        localizeDiscountMessage(node);
        new MutationObserver(function () { localizeDiscountMessage(node); })
          .observe(node, { childList: true, characterData: true, subtree: true });
      });
    }

    watchDiscountMessages(document);

    // Cart drawer HTML is replaced after quantity changes. Re-attach localization safely.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-mt-descuento-mensaje]')) localizeDiscountMessage(node);
          if (node.querySelectorAll) watchDiscountMessages(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
